import { Checkbox as AntdCheckbox } from "antd";
import styled from "styled-components";
import { primitives } from "../../designsystem/primitives";

export const Checkbox = styled(AntdCheckbox)`
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: ${primitives.colors.blue[900]};
  }

  .ant-checkbox-inner:not(#priority) {
    border: 1.5px solid ${primitives.colors.blue[900]};
  }
`;
